import type { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  missingRequiredFields,
  validationFailureBody,
} from './validationFailure'

/**
 * The server's refusal of a company / supplier / TSD contact POSTed without its
 * parent. `CompanyContactModel.company`, `SupplierContactModel.supplier` and
 * `TsdContactModel.tsd` are required (cynque-api-server
 * `entities/models/contact.py`), so a body without the key is a 400.
 *
 * WHY: the mock accepted these, so nothing in dev or e2e could produce the
 * production 400 of 2026-10-28 (Honeybadger 135265502): the Contacts page's
 * "+" let a supplier contact be saved with its Supplier select left empty, and
 * an untouched field is not in the (dirty-fields) body at all.
 *
 * Body and keys mirror the server's, both entries included: it validates the
 * body as one model, then as a list of them, and reports both failures.
 * Undefined when the body is fine.
 */
export async function contactParentRejection(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext,
  { parentKey, modelName }: { parentKey: string; modelName: string }
) {
  const body = await req.json().catch(() => undefined)
  if (missingRequiredFields(body, [parentKey]).length === 0) {
    return undefined
  }
  return res(
    ctx.status(400),
    ctx.json(
      validationFailureBody({
        path: req.url.pathname,
        extra: [
          { message: 'Field required', key: `${modelName}.${parentKey}` },
          {
            message: 'Input should be a valid list',
            key: `list[${modelName}]`,
          },
        ],
      })
    )
  )
}
